import React from 'react';

const Testimonials = () => {
  // 12 logos de clientes - LOCALES (en tu hosting)
  const clientLogos = [
    { id: 1, name: 'Agensa', logo: '/images/clientes/agensa.jpg' },
    { id: 2, name: 'Australis', logo: '/images/clientes/australis.png' },
    { id: 3, name: 'El Molino', logo: '/images/clientes/elmolino.jpg' },
    { id: 4, name: 'Fundación Araya Jeria', logo: '/images/clientes/fundacion.png' },
    { id: 5, name: 'Icafal', logo: '/images/clientes/icafal.jpg' },
    { id: 6, name: 'Interagro', logo: '/images/clientes/interagro.png' },
    { id: 7, name: 'Leenergy', logo: '/images/clientes/leenergy.jpg' },
    { id: 8, name: 'LEPUCV', logo: '/images/clientes/lepucv.jpg' },
    { id: 9, name: 'Seroces', logo: '/images/clientes/seroces.png' },
    { id: 10, name: 'Sercoes', logo: '/images/clientes/sercoes.jpg' },
    { id: 11, name: 'Terratec', logo: '/images/clientes/terratec.jpg' },
    { id: 12, name: 'Viconsa', logo: '/images/clientes/viconsa.jpg' }
  ];

  // Triplicar logos para efecto infinito suave
  const allLogos = [...clientLogos, ...clientLogos, ...clientLogos];

  return (
    <section id="testimonials" className="py-20 md:py-32 bg-white overflow-hidden">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Algunos de Nuestros <span className="text-red-600">Clientes</span>
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">
            Empresas que confían en nuestros servicios
          </p>
        </div>

        {/* Logos Slider */}
        <div className="relative">
          <div className="logos-slider">
            <div className="logos-track">
              {allLogos.map((client, index) => (
                <div
                  key={`${client.id}-${index}`}
                  className="logo-item"
                >
                  <img
                    src={client.logo}
                    alt={client.name}
                    className="logo-img"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* CSS para el slider */}
      <style jsx>{`
        .logos-slider {
          width: 100%;
          overflow: hidden;
          position: relative;
          padding: 2rem 0;
        }

        .logos-track {
          display: flex;
          width: fit-content;
          animation: scroll 40s linear infinite;
          gap: 4rem;
        }

        .logo-item {
          width: 200px;
          height: 100px;
          flex-shrink: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          background: white;
          padding: 1.5rem;
          border-radius: 12px;
          box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
          transition: all 0.3s ease;
        }

        .logo-img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          filter: grayscale(100%) contrast(1.1);
          opacity: 0.7;
          transition: all 0.3s ease;
        }

        .logo-item:hover {
          transform: translateY(-8px);
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
        }

        .logo-item:hover .logo-img {
          filter: grayscale(0%) contrast(1);
          opacity: 1;
        }

        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-33.33%);
          }
        }

        /* Pausar animación al hover */
        .logos-slider:hover .logos-track {
          animation-play-state: paused;
        }

        /* Responsive */
        @media (max-width: 768px) {
          .logos-track {
            gap: 2rem;
            animation: scroll 30s linear infinite;
          }
          
          .logo-item {
            width: 160px;
            height: 80px;
            padding: 1rem;
          }
        }

        @media (max-width: 480px) {
          .logo-item {
            width: 140px;
            height: 70px;
            padding: 0.75rem;
          }
          
          .logos-track {
            gap: 1.5rem;
          }
        }
      `}</style>
    </section>
  );
};

export default Testimonials;
